export enum ForegroundColorType {
  Grey,
  White,
}
